import { Box, Typography } from '@mui/material'
import {
  ButtonWrapper,
  HeaderTitle,
  ImageAndStatsContainer,
  ImageContainer,
  LogoContainer,
  ProjectDescription,
  ProjectHeaderWrapper,
  ProjectSectionContainer,
  StatValue,
  StatWrapper,
  StatsContainer,
  StatsWrapper,
  VideoContainer,
} from './styled'
import GraphismIcon from 'components/Icons/GraphismIcon'
import Image from 'next/image'
import CtaButton from '../CtaButton'
import Testimonial from '../Testimonial'

const ProjectSection = ({
  project,
  video,
  image,
  buttonText,
  buttonUrl,
  alternativeTestimonial,
  alternativeDescription,
  buttonClass,
  removeCtaButtonLink,
}: {
  project: IProject
  video: string
  image: string
  buttonText: string
  buttonUrl: string
  alternativeTestimonial: IAlternativeTestimonial
  alternativeDescription: string
  buttonClass: string
  removeCtaButtonLink: boolean
}) => {
  return (
    <ProjectSectionContainer>
      <ProjectHeaderWrapper>
        <HeaderTitle>Project Spotlight</HeaderTitle>
        <GraphismIcon />
      </ProjectHeaderWrapper>
      <LogoContainer>
        <Image
          src={project.logo.fullSize}
          alt={project.logoAltText || ''}
          layout="fill"
          objectFit="contain"
        />
      </LogoContainer>

      <ImageAndStatsContainer>
        <ImageContainer>
          <Image src={image} alt={project.logoAltText || ''} layout="fill" objectFit="contain" />
        </ImageContainer>
        {project.stats.length > 0 && (
          <StatsContainer>
            <StatsWrapper>
              {project.stats.map((stat, index) => (
                <StatWrapper key={index}>
                  <StatValue>
                    {stat.value}
                    {stat.valueSymbol}
                  </StatValue>
                  <Typography>{stat.description}</Typography>
                </StatWrapper>
              ))}
            </StatsWrapper>
          </StatsContainer>
        )}
      </ImageAndStatsContainer>
      <ProjectDescription>
        <div dangerouslySetInnerHTML={{ __html: alternativeDescription || project.description }} />
      </ProjectDescription>
      <ButtonWrapper>
        <CtaButton
          text={buttonText}
          url={buttonUrl}
          buttonClass={buttonClass}
          removeCtaButtonLink={removeCtaButtonLink}
        />
      </ButtonWrapper>
      {video && (
        <Box component="div" display="flex" flexDirection="column" gap={4}>
          <VideoContainer>
            <iframe
              width="100%"
              height="100%"
              src={video}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              frameBorder="0"
              title="YouTube video player"
            ></iframe>
          </VideoContainer>

          {(project.testimonial || alternativeTestimonial) && (
            <Testimonial
              alternativeTestimonial={alternativeTestimonial}
              projectTestimonial={project.testimonial}
            />
          )}
        </Box>
      )}
    </ProjectSectionContainer>
  )
}

export default ProjectSection
